import { RESOURCE_LOADER } from "../../model/resource.js";
/**
 * @typedef {import("../../model/resource").ResourceElement} ResourceElement
 * @typedef {import("../../model/resource.js").ResourceLoader} ResourceLoader
 */
/**
 * @param {ResourceLoader | null} loader
 */
export function setLoader(loader) {
    /**
     * @param {ResourceElement} resource
     */
    return (resource) => {
        if (loader !== resource[RESOURCE_LOADER] ?? null) {
            resource[RESOURCE_LOADER] = loader;
            return true;
        }
    };
}
